import { createInventorySupplier } from "../../api/inventoryService";

export const useCreateInventorySupplier = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createInventorySupplier(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create inventory supplier:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};